import { Stack, Typography } from '@mui/material';
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import FormTabs from '../components/ChecklistV2/FormTabs';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import { NewFormContext } from '../context/NewFormContext';
import AttToken from '../helpers/attToken';
import { trackEventMatomo,trackEventMatomoVisit } from '../helpers/matomo';
import Checklists from '../service/Checklists';
import { formatLocaleValue } from '../helpers/getNumberMask';

const formService = new Checklists();

export default function FormularioById() {
  const { setModelo } = useContext(NewFormContext);
  const { t } = useTranslation('translation');

  const { id } = useParams();

  const { data, isLoading, isFetching, isSuccess, isError } = useQuery({
    queryKey: ['GET_FORM', id],
    queryFn: async () => {
      const response = toast.promise(async () => {
        const token = await AttToken();
        if (token && id) {
          const response = await formService.getFormById(token, id as string);
          return response;
        }
      }, {
        pending: t('checklists.loadingFormModel'),
        error: t('checklists.errorLoadingFormModel')
      }, { toastId: 'loadingFormModel' });
      return response;
    },
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (isSuccess && data?.data) {
      const formattedForm = {
        ...data.data,
        itens: data.data.itens.map((item: any) => ({
          ...item,
          subitens: item.subitens.map((subitem: any) => {
            if (!["numero", "valorMedida"].includes(subitem.tipo)) return subitem;
            return {
              ...subitem,
              padrao: subitem.padrao !== undefined && subitem.padrao !== null ? formatLocaleValue(subitem.padrao) : subitem.padrao,
              min: subitem.min !== undefined && subitem.min !== null ? formatLocaleValue(subitem.min) : subitem.min,
              max: subitem.max !== undefined && subitem.max !== null ? formatLocaleValue(subitem.max) : subitem.max,
              minNumberVal: subitem.minNumberVal !== undefined && subitem.minNumberVal !== null ? formatLocaleValue(subitem.minNumberVal) : subitem.minNumberVal,
              maxNumberVal: subitem.maxNumberVal !== undefined && subitem.maxNumberVal !== null ? formatLocaleValue(subitem.maxNumberVal) : subitem.maxNumberVal,
            };
          }),
        })),
      };
      setModelo(formattedForm);
    }
  }, [isSuccess, isLoading, isFetching, data, setModelo]);

  useEffect(() => {
    trackEventMatomoVisit('Edição de formulário');
  }, []);

  useEffect(() => {
    if (isSuccess) trackEventMatomo('edição de formulário', 'sucesso', 'carregamento', 'formulário carregado');
    if (isError) trackEventMatomo('edição de formulário', 'erro', 'carregamento', 'falha ao carregar formulário');
  }, [isError, isSuccess]);

  return (
    <Stack direction={'row'} width='100%'>
      <Sidebar />
      <Stack direction='column' width='100%' alignItems='stretch' justifyContent='flex-start' spacing={4} sx={{ backgroundColor: '#F3F3F4' }}>
        <Header />
        <Stack direction='column' width='100%' paddingRight={10} paddingBottom={4} alignItems='center' justifyContent='center' spacing={2}>
          <Typography width='40%' textAlign='center' color='textDisabled' variant='h5' fontWeight={600}>{t('checklists.formEditTitle')}</Typography>
          {isLoading || isFetching ? <Typography variant='h4' fontWeight={600} color='success'>{t('checklists.loadingFormModel')}</Typography> : <FormTabs originalModelo={data?.data} />}
        </Stack>
        <Footer />
      </Stack>
    </Stack>
  );
}
